import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Use 'Routes' instead of 'Switch'
import Navbar from './components/Navbar';
import Shop from './components/Shop'; // Ensure Shop is correctly imported
import About from './components/About'; // Ensure About is correctly imported
import Contact from './components/Contact'; // Ensure Contact is correctly imported
import Cart from './components/Cart'; // Ensure Cart is correctly imported
import Login from './components/Login'; // Import the Login page
import Return from './components/Return'; // Import the Return page
//import TrackOrder from './components/TrackOrder'; // Import the TrackOrder page

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        {/* Define routes for your components */}
        <Route path="/" element={<Shop />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/return" element={<Return />} />
        
        {/* You can add more routes as needed */}
      </Routes>
    </Router>
  );
};

export default App;
